import { Route, Routes } from 'react-router-dom';
import ElearnigHomePage from '../pages/ELearning/Ehomepage';
import About from '../pages/ELearning/about';
import Contact from '../pages/ELearning/contac';
import Program from '../pages/ELearning/programs';
import AdmissionRequirements from '../pages/ELearning/admission requirement';
import DepartmentTable from '../pages/ELearning/course_detail_table';
import PortalApp from '../pages/ELearning/portal_app';
import QuestionPage from '../pages/ELearning/QuestionPage';
import QuixPage from '../pages/ELearning/quiz';
import CourseDetail from '../pages/ELearning/CourseDetail';
import CameraView from '../pages/ELearning/CameraTest';
import ExamStudents from '../pages/KTC Elearning/ExamStudents';
import QuestionPreview from '../pages/ELearning/PreviewQuestion';
import GenerateCertificate from '../pages/certificates/GenerateCertificate';
import UploadCertificates from '../pages/certificates/UploadCertificate';

 export const ElearningRoutes = [
  <Route key="elearningHome" path="/elearningHome" element={<ElearnigHomePage />} />,
  <Route key="about" path="/about" element={<About />} />,
  <Route key="contact" path="/contact" element={<Contact />} />,
  <Route key="programs" path="/programs" element={<Program />} />,
  <Route key="admssionRequirement" path="/admssionRequirement" element={<AdmissionRequirements />} />,
  <Route key="department" path="/department/:departmentId" element={<DepartmentTable />} />,
  <Route key="student-portal" path="/student-portal" element={<PortalApp />} />,
  <Route key="questions" path="/questions" element={<QuestionPage />} />,
  <Route key="quiz" path="/quiz" element={<QuixPage />} />,
  <Route key="coursedetails" path="/coursedetails/:courseId" element={<CourseDetail />} />,
  <Route key="cameraView" path="/cameraView" element={<CameraView />} />,
  <Route key="live-exam-students" path="/live-exam-students" element={<ExamStudents />} />,
  <Route key="questionPreview" path="/QuestionPreview/:class_id/:semester_id/:course_id/:exam_type" element={<QuestionPreview />} />,
  <Route key="generate-certificate" path="/generate-certificate" element={<GenerateCertificate />} />,
  <Route key="upload-certificate" path="/upload-certificate" element={<UploadCertificates />} />,
];